import { render, staticRenderFns } from "./handlingFlow.vue?vue&type=template&id=63799fb4&scoped=true&"
import script from "./handlingFlow.vue?vue&type=script&lang=js&"
export * from "./handlingFlow.vue?vue&type=script&lang=js&"
import style0 from "./handlingFlow.vue?vue&type=style&index=0&id=63799fb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63799fb4",
  null
  
)

export default component.exports